import {Component} from "preact";
import style from './styles.scss';
import Text from "../../../../../common/text";
import ConfigService from "../../../../../../services/ConfigService";
import {createEvent} from "../../../../../../utilities/create-event";
import SimpleDate from "../../../../../common/date/simple-date";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import {brightnessByColor, getColorParts} from "../../../../../../utilities/color";
import Icon from "../../../../../common/icon";

export default class NotificationListItem extends Component {
    static defaultProps = {
        notification: {}
    };

    render(props, state, context) {
        const content = this.props.notification.content;
        const url = this.props.notification.url;
        const read = this.props.notification.visualized;
        const classes = [style.notificationListItem, !read ? style.unread : null].filter(i => i).join(' ');
        const date = <SimpleDate date={this.props.notification.createdAt} />;
        const module = props.notification.module ? ModuleInfoProvider.getModuleByReference(props.notification.module) : null;

        const statusColors = {
            'info': '#00a8ff',
            'success': '#49d400',
            'warning': '#e07c00',
            'danger': '#e02200'
        }

        let iconBackground = getColorParts(props.notification.color) ? props.notification.color : statusColors[props.notification.status || 'info'];
        const iconBackgroundLightness = brightnessByColor(iconBackground);
        const iconColor = iconBackgroundLightness > 175 ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.9)';

        const statusIcons = {
            'info': 'fas-info',
            'success': 'fas-check',
            'warning': 'far-bell',
            'danger': 'fas-exclamation'
        };
        const iconName = props.notification.icon || statusIcons[props.notification.status || 'info'];

        const innerTemplate = () => (
            <div class={style.notificationInner}>
                <div className={style.notificationColumnIcon}>
                    <div className={style.notificationIcon} style={{color: iconBackground}}>
                        <Icon icon={iconName} />
                    </div>
                </div>
                <div className={style.notificationColumnContent}>
                    {props.notification.title ? <div className={style.notificationTitle}><Text translatable={props.notification.title}/></div> : null}
                    <div className={style.notificationBody}><Text translatable={content}/></div>
                    <div className={style.notificationFooter}>
                        <div className={style.module}>{module ? <Text translatable={module.denomination}/> : null}</div>
                        <div className={style.date}>{date}</div>
                    </div>
                </div>
            </div>
        );

        return url ? (
            <a href={url} class={classes} onClick={this.navigateToLink}>{innerTemplate()}</a>
        ) : (
            <div class={classes}>{innerTemplate()}</div>
        );
    }

    navigateToLink = (event) => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        event.preventDefault();
        event.stopPropagation();
        ConfigService.navigateFunction(this.props.notification.url);
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/notification/notification-list-item/index.js